import {Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import {IconComponent} from '../icon/icon.component';
import {Icons} from '../../../model/icon';
import {TextsComponent} from "../texts/texts.component";
import {text} from '../../../functions/localization';
import {Text} from '../../../model/text';
import {ThemeService} from '../../../services/theme.service';
import {LocationDto} from '../../../model/continent';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {NgIf} from '@angular/common';
import {scrollUp} from '../../../functions/scroll-up';
import {FeedbackService} from '../../../services/feedback-service';
import {extractFirstParagraph, extractFirstParagraphFromText} from '../../../functions/extractFirstParagraph';
import {LocalizationService} from '../../../services/localization.service';

@Component({
  selector: 'app-country-info-el',
  imports: [
    IconComponent,
    TextsComponent,
    NgIf
  ],
  templateUrl: './country-info-el.component.html',
  standalone: true,
  styleUrl: './country-info-el.component.scss'
})
export class CountryInfoElComponent implements OnInit, OnChanges {
  constructor(public themeService: ThemeService,
              private router: Router,
              public feedValue: FeedbackService,
              protected localizationService: LocalizationService) {}

  @Input() location: LocationDto = new LocationDto();
  @Input() border: boolean = true;
  @Input() type: 'classic' | 'service' = 'classic';
  @Output() emitClick: EventEmitter<any> = new EventEmitter();

  isServiceExpanded: boolean = false;
  isTextTruncated: boolean = false;
  truncatedText: string = '';
  isMobile: boolean = false;

  isAnimating: boolean = false;
  margin: boolean = false;
  openFull: boolean = false;

  tour: Text[] = [
    {text: ['туры', 'tours']}
  ];
  city: Text[] = [
    {text: ['популярные города', 'popular cities']}
  ];
  hotel: Text[] = [
    {text: ['роскошные отели', 'luxury hotels']}
  ];

  ngOnInit() {
    if (window.innerWidth < 769) {
      this.city = [
        {text: ['города', 'cities']}
      ];
      this.hotel = [
        {text: ['отели', 'hotels']}
      ]
    }
    if (window.innerWidth < 571) {
      this.isMobile = true;
    }
    this.hasSpace();
    this.checkTextTruncation();
  }

  get objectPosition() {
    // if (!this.isMobile) {
    //   return ''
    // }
    if (this.location.objectPosition !== undefined) {
      let position = this.location.objectPosition;
      if (this.isMobile) {
        const parts = position.split(' ');
        const firstPart = parts[0];
        const match = firstPart.match(/(-?\d+)px/);
        if (match) {
          const value = parseInt(match[1], 10);
          const newValue = value + 5;
          parts[0] = `${newValue}px`;
          position = parts.join(' ');
        }
      }
      return position;
    }
    return '';
  }

  get scale() {
    // if (!this.isMobile) {
    //   return ''
    // }
    if (this.location.scale !== undefined) {
      return this.location.scale;
    }
    return ''
  }

  splitTextToArray(textArray: string[]): Text[] {
    if (!textArray || textArray.length === 0) {
      return [];
    }
    const result: Text[] = [];
    const splitTexts = textArray.map(text =>
      text.split('\n').map(line => line.trim() === '' ? ' ' : line)
    );
    const maxLines = Math.max(...splitTexts.map(text => text.length));
    for (let i = 0; i < maxLines; i++) {
      const currentLines: string[] = [];
      splitTexts.forEach((splitText, index) => {
        if (i < splitText.length) {
          currentLines.push(splitText[i]);
        } else {
          currentLines.push(' ');
        }
      });
      const isEmptyLine = currentLines.every(line => line.trim() === '');
      const finalLines = isEmptyLine
        ? currentLines.map(() => ' ')
        : currentLines;
      const textItem = new Text({
        text: finalLines,
        transfer: true
      });

      result.push(textItem);
    }

    return result;
  }

  getMaxWidth(str: string): string {
    if (!str?.trim()) {
      return 'max-width: 0ch;';
    }
    const cleanStr = str.trim();
    const words = cleanStr.match(/[a-zA-Zа-яА-ЯёЁ0-9-]+/g);
    if (!words || words.length === 0) {
      return 'max-width: 0ch;';
    }
    let maxLength = 0;
    for (const word of words) {
      const cleanWord = word.replace(/^-+|-+$/g, '');
      if (cleanWord.length > maxLength) {
        maxLength = cleanWord.length;
      }
    }
    const padding = 2;
    let result = maxLength + padding;
    return `max-width: ${result}ch;`;
  }

  getVisualMaxWidth(str: string): string {
    if (!str || str.trim().length === 0) {
      return 'max-width: 0ch;';
    }
    const getCharWidth = (char: string): number => {
      if ('шщШЩ'.includes(char)) return 1.8;
      if ('жмюЖМЮwmWM'.includes(char)) return 1.6;
      if (/[а-яёa-z]/i.test(char)) return 1.2;
      if ('il1|Ііїј'.includes(char)) return 0.8;
      return 1.0;
    };
    const words = str.match(/[\wа-яА-ЯёЁ-]+/g) || [];
    if (words.length === 0) {
      return 'max-width: 0ch;';
    }
    let maxVisualWidth = 0;
    for (const word of words) {
      let wordWidth = 0;
      for (const char of word) {
        wordWidth += getCharWidth(char);
      }
      if (wordWidth > maxVisualWidth) {
        maxVisualWidth = wordWidth;
      }
    }
    const finalWidth = Math.ceil(maxVisualWidth) + 1;
    if (finalWidth + 2 <= 13) {
      this.margin = true;
      return 'max-width: 13ch'
    }
    return `max-width: ${finalWidth - 3}ch;`;
  }

  hasSpace(): void {
    if (text([this.location.titleRu, this.location.titleEn]).includes(' ')) {
      this.margin = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['location']) {
      this.checkTextTruncation();
    }
  }

  get localizedText(): string {
    if (!this.location) return '';
    return text([this.location.descriptionRu || '', this.location.descriptionEn || '']);
  }

  checkTextTruncation(): void {
    const localizedText = this.localizedText;
    if (!localizedText || localizedText.trim() === '') {
      this.isTextTruncated = false;
      this.truncatedText = '';
      return;
    }
    let maxLength = 270;
    if (window.innerWidth > 1500) {
      maxLength = 370;
    }
    if (localizedText.length > maxLength) {
      this.isTextTruncated = true;
      const truncated = localizedText.substring(0, maxLength);
      const lastSpaceIndex = truncated.lastIndexOf(' ');
      this.truncatedText = lastSpaceIndex > 0
        ? localizedText.substring(0, lastSpaceIndex)
        : truncated;
    } else {
      this.isTextTruncated = false;
      this.truncatedText = localizedText;
    }
  }

  get subtitleTextShort() {
    if (this.localizationService.getActiveLang() === 0) {
      return extractFirstParagraphFromText(this.location.descriptionRu) + ' '
    } else {
      return extractFirstParagraphFromText(this.location.descriptionEn) + ' '
    }
  }

  get subtitleTextFull() {
    if (this.localizationService.getActiveLang() === 0) {
      return this.location.descriptionRu + ' ';
    } else {
      return this.location.descriptionEn + ' ';
    }
  }

  get subtitleTextFullHtml() {
    const text = this.localizationService.getActiveLang() === 0
      ? this.location.descriptionRu
      : this.location.descriptionEn;
    return text?.replace(/\n/g, '<br>') || '';
  }


  startAnimation(event: MouseEvent) {
    const iconContainer = event.currentTarget as HTMLElement;
    const icon = iconContainer.querySelector('.country-info-icon') as HTMLElement;
    if (this.isAnimating) return;
    this.isAnimating = true;
    icon.classList.add('animating');
    icon.addEventListener('animationend', () => {
      icon.classList.remove('animating');
      this.isAnimating = false;
    }, { once: true });
  }

  getCorrectEnding(n: number, str: string) {
    let r = ['', ''];
    switch (str) {
      case 'tour':
        if (n == 0) {
          r = ['туров', 'tours'];
        }
        if (n == 1) {
          r = ['тур', 'tour'];
        }
        if (n > 1 && n < 5) {
          r = ['тура', 'tours'];
        }
        if (n >= 5) {
          r = ['туров', 'tours'];
        }
        break;
      case 'city':
        if (n == 0) {
          r = ['городов', 'cities'];
        }
        if (n == 1) {
          r = ['город', 'city'];
        }
        if (n > 1 && n < 5) {
          r = ['города', 'cities'];
        }
        if (n >= 5) {
          r = ['городов', 'cities'];
        }
        break;
      case 'hotel':
        if (n == 0) {
          r = ['отелей', 'hotels'];
        }
        if (n == 1) {
          r = ['отель', 'hotel'];
        }
        if (n > 1 && n < 5) {
          r = ['отеля', 'hotels'];
        }
        if (n >= 5) {
          r = ['отелей', 'hotels'];
        }
        break;
    }
    return r;
  }

  emitObj(obj?: string) {
    if (this.type === 'service') {
      return
    }
    const continent = this.location.continent?.url ?? '';
    const country = this.location.url ?? '';
    scrollUp();
    this.router.navigate( ['destinations/' + continent + '/' + country] ).then(r => r);
  }

  getInvert() {
    return this.themeService.getTheme() == 'black-theme';
  }

  get background() {
    if (this.type === 'classic') {
      return this.location.image ? environment.s3Prefix +  this.location.image : 'app/assets/images/adventure.jpeg';
    }
    if (this.type === 'service') {
      return this.location.image;
    }
    return 'app/assets/images/adventure.jpeg'
  }

  openFeedback() {
    if (this.location.feedValue !== undefined) {
      this.feedValue.setFeedbackValue(this.location.feedValue)
    }
    this.router.navigate([ '/feedback' ]).then(r => r)
  }

  openService() {
    let x = this.location.titleEn.replace(/\s+/g, '_');
    if (x === 'Travel_PA') {
      const y = 'Personal Assistance'
      x = y.replace(/\s+/g, '_');
    }
    const url = x.toLowerCase()
    this.router.navigate([ '/services/' + url ]).then(r => r);
  }

  protected readonly Icons = Icons;
  protected readonly text = text;
  protected readonly environment = environment;
}
